import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoConsultaLogLiberacaoSiad({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'consultalogliberacaosiad', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoConsultaLogLiberacaoSiad({ payload }) {
  try {
    const { loli_codigo, params } = payload;

    yield call(api.delete, `consultalogliberacaosiad/${loli_codigo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaoconsultalogliberacaosiad, params } = payload;

    yield call(
      api.post,
      'consultalogliberacaosiad',
      operacaoconsultalogliberacaosiad
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/consultalogliberacaosiad');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { loli_codigo } = payload;

    const { data } = yield call(
      api.get,
      `consultalogliberacaosiad/${loli_codigo}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaoconsultalogliberacaosiad, params } = payload;

    yield call(
      api.put,
      'consultalogliberacaosiad',
      operacaoconsultalogliberacaosiad
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/consultalogliberacaosiad');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'consultalogliberacaosiad', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaoconsultalogliberacaosiad/CONSULTALOGLIBERACAOSIAD_IN_REQUEST',
    requestOperacaoConsultaLogLiberacaoSiad
  ),
  takeLatest(
    '@operacaoconsultalogliberacaosiad/DELETE_CONSULTALOGLIBERACAOSIAD',
    deleteOperacaoConsultaLogLiberacaoSiad
  ),
  takeLatest(
    '@operacaoconsultalogliberacaosiad/SUCCESS_REMOVE',
    requestOperacaoConsultaLogLiberacaoSiad
  ),
  takeLatest(
    '@operacaoconsultalogliberacaosiad/STORE_CONSULTALOGLIBERACAOSIAD',
    store
  ),
  takeLatest(
    '@operacaoconsultalogliberacaosiad/FIND_CONSULTALOGLIBERACAOSIAD',
    find
  ),
  takeLatest(
    '@operacaoconsultalogliberacaosiad/UPDATE_CONSULTALOGLIBERACAOSIAD',
    update
  ),
  takeLatest(
    '@operacaoconsultalogliberacaosiad/RECORD_FILTERING',
    applyedFilters
  ),
]);
